export const site = {
  name: 'Somalia National Pavilion',
  exhibition: 'SADDEXLEEY',
  biennale: "61st International Art Exhibition of La Biennale di Venezia",
  location: 'Palazzo Caboto, Castello 1645, Venice',
  dates: '9 May — 22 November 2026',
  description:
    'Somalia’s first official National Pavilion at the Venice Biennale, presenting Somali contemporary art through exhibition, research and public programmes.',
  email: 'info@somaliapavilion.so',
  pressEmail: 'liban@somaliapavilion.so',
  instagram: 'https://www.instagram.com/somaliapavilion/',
  x: 'https://x.com/SomaliaPavilion',
};

export const navigation = [
  { label: 'Exhibition', to: '/exhibition' },
  { label: 'Artists', to: '/artists' },
  { label: 'Programme', to: '/programme' },
  { label: 'Press', to: '/press' },
  { label: 'About', to: '/about' },
];

export const exhibition = {
  title: 'SADDEXLEEY',
  pronunciation: 'sahd-dehkh-leey',
  introduction:
    'SADDEXLEEY takes its name from a Somali poetic form built through a triadic structure. Across three floors, three artists work through language, moving image and material to consider memory, movement and belonging.',
  statement: [
    'Rooted in Somalia’s tradition of poetry as a living cultural form, the exhibition unfolds through scent, sound and image, forming a sensory experience across three movements.',
    'Warsan Shire gives domestic memory and displacement a spatial and oral presence. Asmaa Jama constructs an audiovisual architecture through film, sound and installation. Ayan Farah allows land, sediment, textile and time to accumulate within material surfaces.',
    'The practices remain distinct while meaning develops between them through repetition, variation and relation. Poetry becomes social architecture: a way of carrying knowledge, history and collective memory through voices, spaces and materials.',
  ],
  movements: [
    {
      title: 'Word',
      artist: 'Warsan Shire',
      text: 'Poetry, voice and the domestic interior hold intimacy, interruption, departure and return.',
    },
    {
      title: 'Sound & Image',
      artist: 'Asmaa Jama',
      text: 'Film and installation draw the East African coast into a field of myth, archive and movement.',
    },
    {
      title: 'Matter',
      artist: 'Ayan Farah',
      text: 'Textile, earth, shell and pigment record geography, time and the movement of materials.',
    },
  ],
};

export const artists = [
  {
    slug: 'ayan-farah',
    name: 'Ayan Farah',
    role: 'Textile, earth and material time',
    image: '/assetsfolder/artist2.jpg',
    bio:
      'Ayan Farah is a Somali artist based in Stockholm. Working with painting, textiles and material-led research, her practice explores landscape as physical, political and poetic systems. She works with locally sourced sediment and natural elements, tracing the movement of matter across borders and ecologies where geology, labour and colonial histories converge.',
  },
  {
    slug: 'asmaa-jama',
    name: 'Asmaa Jama',
    role: 'Film, performance and audiovisual architecture',
    image: '/assetsfolder/Asmaa Jama PHOTO.jpg',
    bio:
      'Asmaa Jama is a Somali poet, filmmaker and multidisciplinary artist based in Bristol. Their work combines visual storytelling, poetry and performance with archival memory, myth and narratives shaped by movement and place. Their films have been presented at BAFTA-qualifying festivals including BlackStar and Aesthetica.',
  },
  {
    slug: 'warsan-shire',
    name: 'Warsan Shire',
    role: 'Poetry, voice and domestic memory',
    image: '/assetsfolder/WarsanShire.jpeg',
    bio:
      'Warsan Shire is a Somali poet and writer. Her debut collection, Bless the Daughter Raised by a Voice in Her Head, was published in 2022. She was the first Young Poet Laureate for London and has collaborated with Beyoncé Knowles-Carter on Lemonade and Black Is King. Her writing gives language to home, exile, intimacy and survival.',
  },
];

const previewImages = [1, 4, 7, 10, 13, 16, 19, 22, 25, 27, 29, 31].map((number) => ({
  src: `/assetsfolder/EVENT15APRILSOMALIANATIONALPAVILION (${number}).jpg`,
  alt: `Somalia National Pavilion preview in Mogadishu, photograph ${number}`,
  credit: '© Somalia National Pavilion',
}));

const veniceInaugurationImages = [
  ['01.jpg', 'Guests gathering beneath the Somalia National Pavilion banner during the Venice inauguration'],
  ['02.jpg', 'Visitors entering SADDEXLEEY at Palazzo Caboto during the Venice inauguration'],
  ['03.jpg', 'The SADDEXLEEY exhibition identity and curatorial text at Palazzo Caboto'],
  ['04.jpg', 'Visitors moving through the stairwell of the Somalia National Pavilion'],
  ['05.jpg', 'A visitor encountering Ayan Farah’s material installation in SADDEXLEEY'],
  ['06.jpg', 'Asmaa Jama during the inauguration of SADDEXLEEY in Venice'],
  ['07.jpg', 'Visitors engaging with an installation in SADDEXLEEY'],
  ['08.jpg', 'Opening performance during the inauguration of the Somalia National Pavilion'],
].map(([file, alt]) => ({
  src: `/assetsfolder/events/venice-inauguration/${file}`,
  alt,
  credit: '© Somalia National Pavilion',
}));

const saddexleey02Images = [
  ['01.jpg', 'Live performance during SADDEXLEEY 02 in Mogadishu'],
  ['02.jpg', 'The Blood Coast screening during SADDEXLEEY 02'],
  ['03.jpg', 'A speaker introducing the SADDEXLEEY 02 public programme'],
  ['04.jpg', 'Performers moving across the SADDEXLEEY 02 outdoor screening space'],
  ['05.jpg', 'Audience and stage viewed from above during SADDEXLEEY 02'],
  ['06.jpg', 'Artists in conversation before the film screening at SADDEXLEEY 02'],
  ['07.jpg', 'Audience members watching the SADDEXLEEY 02 programme'],
  ['08.jpg', 'Branded popcorn prepared for guests at SADDEXLEEY 02'],
].map(([file, alt]) => ({
  src: `/assetsfolder/events/saddexleey-02/${file}`,
  alt,
  credit: '© Somalia National Pavilion',
}));

const schoolVisitImages = [
  'img-0420.webp', 'img-0421.webp', 'img-0422.webp', 'img-0423.webp', 'img-0424.webp',
  'img-0425.webp', 'img-0426.webp', 'img-0427.webp', 'img-0428.webp', 'img-0429.webp',
  'img-0430.webp', 'img-0432.webp', 'img-0434.webp', 'img-0436.webp', 'img-0441.webp',
  'img-0442.webp', 'img-0445.webp', 'img-0451.webp', 'img-0454.webp', 'img-0458.webp',
  'img-0459.webp', 'img-0460.webp', 'img-0461.webp',
].map((file, index) => ({
  src: `/assetsfolder/events/saddexleey-02/school-visit/${file}`,
  alt: `Dream International School students visiting the PLAYTIME exhibition, photograph ${index + 1}`,
  credit: '© Somalia National Pavilion',
}));

export const events = [
  {
    slug: 'somali-film-programme-2026',
    status: 'Upcoming',
    eyebrow: 'Venice · Cinema',
    title: 'Somalia Pavilion Film Programme',
    date: '11–13 September 2026',
    location: 'Palazzo Caboto, Castello 1645, Venice',
    summary:
      'A programme of contemporary Somali cinema bringing together fiction, documentary and experimental films by Somali filmmakers worldwide.',
    body: [
      'Presented as part of the public programme of SADDEXLEEY, all works were selected through an open call. Exploring childhood, memory, grief, faith, family and inherited traditions, the programme brings together distinct voices, generations and perspectives rather than offering a single account of Somali experience.',
      'The programme includes the international premiere of Hussein Boon’s feature-length film The Flames of Tradition. Filmed in Borama with an entirely Somali cast and crew, the drama follows two young people navigating love amid inherited tensions and social conflict.',
      'Coinciding with the closing days of the 83rd Venice International Film Festival, the programme expands the Somalia National Pavilion’s presentation beyond the exhibition and highlights the breadth of contemporary Somali filmmaking. It is independently presented and is not affiliated with or included in the Festival’s official selection.',
    ],
    curatedBy: ['Idel Rasheed'],
    collaborators: ['Waaberi Phone'],
    rsvpUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfaxt1kuVb5sIndQLLI6TIGqISwI5gHSMYGZJzhb7aVOcFudg/viewform',
    rsvpEmbedUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfaxt1kuVb5sIndQLLI6TIGqISwI5gHSMYGZJzhb7aVOcFudg/viewform?embedded=true',
    pressRelease: '/assetsfolder/press/Somalia_National_Pavilion_Film_Programme_Press_Release.pdf',
    highlights: ['Contemporary Somali cinema', 'International premiere · The Flames of Tradition', 'Selected through an open call'],
    films: [
      { title: 'MUNA', credit: 'Warda Mohamed', runtime: '19 min', image: '/assetsfolder/events/somali-film-programme-2026/muna.webp' },
      { title: 'GROWING PAINS II', credit: 'Wasima Farah & Bakar Elmi', runtime: '7 min 56 sec', image: '/assetsfolder/events/somali-film-programme-2026/growing-pains-ii.webp' },
      { title: 'Isn’t This What I’m Supposed to Feel', credit: 'Abdimalik Ahmed', runtime: '7 min', image: '/assetsfolder/events/somali-film-programme-2026/isnt-this-what-im-supposed-to-feel.webp' },
      { title: 'The Flames of Tradition', credit: 'Hussein Boon', runtime: '73 min', image: '/assetsfolder/events/somali-film-programme-2026/the-flames-of-tradition.webp' },
      { title: 'WARYA', credit: 'Miski Omar', runtime: '13 min 11 sec', image: '/assetsfolder/events/somali-film-programme-2026/warya.webp' },
      { title: 'A Journey Back to Allah', credit: 'Qasim A. Ali & Feisal Mohamed', runtime: '4 min 42 sec', image: '/assetsfolder/events/somali-film-programme-2026/a-journey-back-to-allah.webp' },
      { title: 'I’ll Wait for You by the Sea', credit: 'Rasia Yusuf', runtime: '6 min 47 sec', image: '/assetsfolder/events/somali-film-programme-2026/ill-wait-for-you-by-the-sea.webp' },
      { title: 'Suffice (Deeqa)', credit: 'Aar Maanta', runtime: '7 min', image: '/assetsfolder/events/somali-film-programme-2026/suffice.webp' },
      { title: 'Gacal', credit: 'Mohammad H. Ali', runtime: '60 min', image: '/assetsfolder/events/somali-film-programme-2026/gacal.webp' },
    ],
    screeningSchedule: [
      {
        date: 'Saturday, 12 September',
        time: 'From 17:00',
        films: ['MUNA', 'GROWING PAINS II', 'Isn’t This What I’m Supposed to Feel', 'The Flames of Tradition'],
        note: 'Live Q&A with Hussein Boon',
      },
      {
        date: 'Sunday, 13 September',
        time: 'From 17:00',
        films: ['WARYA', 'A Journey Back to Allah', 'I’ll Wait for You by the Sea', 'Suffice (Deeqa)', 'Gacal'],
      },
    ],
    encounterNote:
      'The Saturday programme concludes with a live Q&A with filmmaker Hussein Boon.',
  },
  {
    slug: 'saddexleey-02',
    status: 'Past event',
    eyebrow: 'Mogadishu · Public Programme',
    title: 'SADDEXLEEY 02',
    date: '13 August 2026',
    location: 'Raadka Fanka, Taleh, Hodan, Mogadishu',
    summary:
      'The first domestic public programme connected to the Pavilion brought film, photography and live painting together in Mogadishu through a triadic evening of encounter.',
    body: [
      'The programme presented Asmaa Jama’s film The Blood Coast (2026), the photography exhibition PLAYTIME by Fardowsa Hussein and a live painting by Abdinasir 4C. Developed with Raadka Fanka and Barshinemo, the event connected the Pavilion’s presence in Venice with an in-person cultural gathering in Mogadishu.',
      'SADDEXLEEY 02 extended the exhibition’s triadic method beyond Palazzo Caboto: three practices, three modes of encounter and one shared public space.',
      'PLAYTIME later welcomed students from Dream International School, extending the photography exhibition into an educational encounter with young audiences.',
    ],
    highlights: [
      'The Blood Coast (2026) · Asmaa Jama',
      'PLAYTIME · Fardowsa Hussein',
      'Live painting · Abdinasir 4C',
    ],
    partners: ['Raadka Fanka', 'Barshinemo'],
    videoUrl: 'https://www.youtube-nocookie.com/embed/aG6W48huPOs',
    videoAspect: 'landscape',
    images: saddexleey02Images,
    schoolVisit: {
      title: 'Dream International School visits PLAYTIME',
      description:
        'A guided school visit invited young audiences to encounter Fardowsa Hussein’s photography through close looking, conversation and shared reflection.',
      images: schoolVisitImages,
    },
    credit: '© Somalia National Pavilion',
  },
  {
    slug: 'venice-inauguration',
    status: 'Past event',
    eyebrow: 'Venice · Inauguration',
    title: 'SADDEXLEEY — Inauguration in Venice',
    date: '8 May 2026',
    location: 'Palazzo Caboto, Castello 1645, Venice',
    summary:
      'Somalia inaugurated its first official National Pavilion at the Venice Biennale during the preview days of the 61st International Art Exhibition.',
    body: [
      'Across three floors, SADDEXLEEY brought together Ayan Farah, Asmaa Jama and Warsan Shire through textile, film, installation, sound and poetry.',
      'The inauguration opened a six-month public presentation at Palazzo Caboto and marked a historic moment for Somalia’s contemporary cultural presence internationally.',
    ],
    highlights: ['Three exhibition artists across three floors', 'RUUN by Salman Dirir', 'Live painting by Abdinasir 4C', 'Scent, sound, film and material'],
    exhibitionArtists: ['Ayan Farah', 'Asmaa Jama', 'Warsan Shire'],
    programmeArtists: [
      {
        name: 'Salman Dirir',
        role: 'Programme artist · RUUN',
        bio: 'Salman Dirir is a multidisciplinary Somali artist working across film, movement and sound. Rooted in research into heritage and bicultural identity, his practice resists cultural erasure while exploring how ancestry, migration and memory shape lived experience. RUUN, developed through fieldwork in the Somali Peninsula, exists as both a documentary film and a movement-based performance, bringing archival memory, ritual practice and the body into a poetic inquiry into truth and its instability. Dirir also works as an educator at the Van Abbemuseum.',
      },
      {
        name: 'Abdinasir 4C',
        role: 'Programme / contributing artist · Live painting',
        bio: 'Somali artist Abdinasir 4C contributed a live painting that unfolded alongside the Pavilion’s inauguration. Presented as part of the opening programme, the work extended the formal inauguration into a public, durational process of image-making.',
      },
    ],
    videoUrl: 'https://www.youtube-nocookie.com/embed/lCch_Wu40zc',
    videoAspect: 'portrait',
    images: veniceInaugurationImages,
    credit: '© Somalia National Pavilion',
  },
  {
    slug: 'mogadishu-preview',
    status: 'Past event',
    eyebrow: 'Mogadishu · National Preview',
    title: 'Somalia National Pavilion — Mogadishu Preview',
    date: '15 April 2026',
    location: 'Mogadishu, Somalia',
    summary:
      'A national presentation introduced Somalia’s first Venice Biennale participation to public institutions, diplomats, educators, artists, businesses and civil society.',
    body: [
      'Hosted by the Embassy of Italy in Mogadishu, the preview introduced SADDEXLEEY, its triadic curatorial structure and the practices of Ayan Farah, Asmaa Jama and Warsan Shire.',
      'The gathering positioned the Pavilion as both an international contemporary-art project and part of a longer conversation about cultural memory, intergenerational exchange and Somalia’s cultural presence abroad.',
    ],
    highlights: ['National and diplomatic presentation', 'Curatorial introduction', 'Programme contribution · Live painting by Abdinasir 4C'],
    images: previewImages,
    credit: '© Somalia National Pavilion',
  },
];

export const pressCoverage = [
  {
    outlet: 'Forbes',
    date: '6 May 2026',
    title: '24 Hours In Venice For The Biennale—A City Of Light And Art',
    description: 'A Venice itinerary identifying the first Somalia Pavilion as a recommended Castello stop.',
    url: 'https://www.forbes.com/sites/joanneshurvell/2026/05/06/24-hours-in-venice-a-city-of-light-and-art/',
    featured: true,
  },
  {
    outlet: 'Surface',
    date: 'May 2026',
    title: 'Seven Significant National Pavilions from the 2026 Venice Biennale',
    description: 'Selects SADDEXLEEY among seven significant national presentations.',
    url: 'https://www.surfacemag.com/articles/seven-significant-pavilions-from-the-2026-venice-biennale/',
    featured: true,
  },
  {
    outlet: 'FAD Magazine',
    date: '13 May 2026',
    title: 'Review: The Good, The Bad and The Venice Biennale',
    description: 'Identifies Somalia as a strong first-time and off-site national presentation.',
    url: 'https://fadmagazine.com/2026/05/13/venice-biennale-2026-review/',
    featured: true,
  },
  {
    outlet: 'Arab News',
    date: '9 May 2026',
    title: 'Somalia speaks in Venice: A historic national pavilion rises at 61st Biennale',
    description: 'A substantial opening account focused on cultural reclamation, memory and artistic complexity.',
    url: 'https://www.arabnews.com/node/2642889/amp',
    featured: true,
  },
  {
    outlet: 'Deutsche Welle',
    date: '3 July 2026',
    title: 'Somalia’s first pavilion at the Venice Art Biennale',
    description: 'A dedicated international broadcast segment from Venice.',
    url: 'https://www.dw.com/en/somalias-first-pavillion-at-the-venice-art-biennale/video-77725232',
  },
  {
    outlet: 'Africanews',
    date: '9 May 2026',
    title: 'African nations showcase art at Venice Biennale',
    description: 'Opening-week video coverage of the Pavilion’s poetry and domestic installation.',
    url: 'https://www.africanews.com/2026/05/09/african-nations-showcase-art-at-venice-biennale/',
  },
  {
    outlet: 'ArtReview',
    date: '12 May 2026',
    title: 'Ayan Farah and Asmaa Jama on Representing Somalia at the 61st Venice Biennale',
    description: 'The artists discuss material, film, coastline, memory and artistic lineage.',
    url: 'https://artreview.com/ayan-farah-and-asmaa-jama-on-representing-somalia-at-the-61st-venice-biennale/',
  },
  {
    outlet: 'Central Saint Martins',
    date: '26 May 2026',
    title: 'Asmaa Jama represents Somalia at the Venice Biennale',
    description: 'An interview about The Blood Coast, embodied poetry and the Indian Ocean.',
    url: 'https://www.arts.ac.uk/colleges/central-saint-martins/stories/csm-student-asmaa-jama-represents-somalia-at-the-venice-biennale',
  },
];

export const journal = {
  status: 'Articles forthcoming',
  introduction:
    'The Journal will publish commissioned writing from Cultural Advisory Board members, artists, curators and institutional contributors. It is being built as a durable editorial record rather than a stream of promotional updates.',
  strands: [
    ['Cultural Advisory Board essays', 'Critical perspectives on Somali art, culture, heritage and international representation.'],
    ['Commissioner and institutional reflections', 'Mandate, public value, cultural diplomacy, governance and long-term legacy.'],
    ['Curatorial notes', 'The exhibition’s poetic, spatial and material framework.'],
    ['Artist conversations', 'Interviews and first-person reflections with Pavilion and programme artists.'],
    ['Venice–Mogadishu dispatches', 'Programme reports connecting the Pavilion’s two active geographies.'],
    ['Education and legacy', 'Archives, museum learning, knowledge transfer and future cultural infrastructure.'],
  ],
};

export const about = {
  governmentalPositioning: [
    'The Somalia National Pavilion is the official national platform through which Somalia participates in La Biennale di Venezia. Presented with the mandate of the Federal Government of Somalia, it marks the country’s first national participation and places Somali artists, cultural practitioners and institutions at the centre of Somalia’s own international cultural presentation.',
    'SADDEXLEEY is the Pavilion’s inaugural exhibition at the 61st International Art Exhibition. The Pavilion’s purpose extends beyond a single exhibition: it is being developed as a framework for artistic production, research, public programming, documentation, institutional collaboration and Somalia’s future participation in international art and architecture platforms.',
  ],
  research: {
    period: 'July 2025 — February 2026',
    title: 'Research, travel and sustained listening',
    paragraphs: [
      'The Somalia National Pavilion developed through a sustained period of research, travel and dialogue. Beginning at the National Museum of Somalia, the process moved through Garowe and Eyl and extended to Nairobi, Lamu and London. These journeys connected artists, writers, poets, musicians, cultural workers and institutions through a method shaped by listening rather than by imposing a fixed account of national culture.',
      'These experiences informed the development of SADDEXLEEY in response to In Minor Keys. Poetry became both a subject and an organising structure: a way of understanding rhythm, relation, repetition and the movement of knowledge between people, places and artistic forms.',
    ],
    locations: ['National Museum of Somalia', 'Garowe', 'Eyl', 'Nairobi', 'Lamu', 'London'],
  },
  foundations: [
    {
      title: 'HOY',
      year: '2023',
      text: 'HOY marked the first contemporary-art exhibition hosted by the National Museum of Somalia following its reopening after nearly three decades, bringing contemporary practice into renewed dialogue with the institution.',
    },
    {
      title: 'A Window to Her Worlds',
      year: '2025',
      text: 'Presented at the National Museum of Somalia, A Window to Her Worlds brought together Somalia-based women working across photography, painting, film, poetry and Buraanbur performance. The exhibition explored cultural identity, resilience, peace and women’s creative expression.',
    },
  ],
};

export const leadership = [
  {
    name: 'Abdirahman Yusuf Mohamud',
    role: 'Commissioner',
    image: '/assetsfolder/commissioner.jpeg',
    bio: 'Commissioner of Somalia’s inaugural National Pavilion and Cultural Advisor to the Office of the Prime Minister.',
  },
  {
    name: 'Mohamed Mire',
    role: 'Curator',
    image: '/assetsfolder/MIRE PHOTO.jpeg',
    bio: 'Somali curator and cultural producer working across photography, museums and contemporary artistic practice.',
  },
  {
    name: 'Fabio Scrivanti',
    role: 'Curator',
    image: '/assetsfolder/Fabio Scrivanti Portrait.jpg.jpeg',
    bio: 'Venice-based project manager and curator with extensive experience delivering international exhibitions.',
  },
];

export const team = [
  ['Mahamed Jama', 'Project Manager'],
  ['Ismail Siad', 'Project Coordinator'],
  ['Liban Mohammed (Sheeko)', 'PR & Media Relations'],
  ['Warsame Shiidley', 'Cultural Advisory Board'],
  ['Ibrahim Hirsi', 'Cultural Advisory Board'],
  ['Abdullahi Abshir (Sanco)', 'Cultural Advisory Board'],
];

export const institutions = {
  patronage: [
    ['Office of the Prime Minister', '/assetsfolder/opm.jpg', 'https://opm.gov.so/'],
    ['Ministry of Foreign Affairs Somalia', '/assetsfolder/MFA.png', 'https://mfa.gov.so'],
    ['Ministry of Information, Culture and Tourism', '/assetsfolder/Minister of Information, Culture, and Tourism.jpg', 'https://moi.gov.so/'],
  ],
  supporters: [
    ['Galerie Nordenhake', '/assetsfolder/Galerie nordenhake.jpeg', 'https://nordenhake.com'],
    ['Kadel Willborn', '/assetsfolder/Kadel willborn.jpeg', 'http://www.kadel-willborn.de'],
    ['NMDC', '/assetsfolder/NMDC - Official Logo.png', 'https://nmdcinvest.com/'],
    ['National Museum of Somalia', '/assetsfolder/National Musuem Somalia.jpeg', null],
    ['GHSRF', '/assetsfolder/GHSRF.jpeg', null],
    ['Ibaar', '/assetsfolder/Ibaar Logo.jpeg', null],
    ['Swedish Arts Council', 'https://kulturradet.imagevault.app/publishedmedia/z4bsi2j58sqd5x66aqdw/sweartscounc.pos.png', 'https://www.kulturradet.se/en/english/'],
  ],
  partners: [
    ['DE_FORM', null, 'https://de-form.agency/'],
    ['Venice Art Factory', '/assetsfolder/veniceartfactory.png', 'https://www.veniceartfactory.org'],
    ['Know How Production', '/assetsfolder/Know How Production.jpg', 'https://www.knowhow-production.com'],
  ],
};

export const venue = {
  name: 'Palazzo Caboto',
  address: 'Via Giuseppe Garibaldi, Castello 1645, 30122 Venice, Italy',
  image: '/assetsfolder/Venue .png',
  schedule: [
    ['Tuesday — Saturday', '11:00—19:00'],
    ['Sunday & Monday', 'Closed'],
  ],
};

